var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Text } from 'shared/components/ui';
export var MultiLineReadOnly = function (_a) {
    var text = _a.text, dataTestId = _a["data-testid"];
    return (_jsx(Box, { children: text.split(/\n/g).map(function (line, i) { return (_jsx(Text, __assign({ "data-testid": dataTestId, pb: 2 }, { children: line }), i)); }) }));
};
